import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { AssociatedPaymentMethodItem } from '@/models/ps-management/multi-methods.model';

export default class GetAssociatedPaymentMethodListRequest extends ApiResourceMethod<AssociatedPaymentMethodItem[]> {
  public perform(multiMethodId: string): Promise<AssociatedPaymentMethodItem[]> {
    return this.performer.requestWithMapper(
      { url: `${multiMethodId}/billingPaymentMethodList` },
      (payload: BaseResponse<AssociatedPaymentMethodItem[]>) => {
        return payload.data;
      },
    );
  }
}
